import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`
export const Subheading = tw.h1`font-bold text-primary-500`
export const SubheadingCustom = tw.h6`text-sm text-secondary-100 font-normal`
